import React from 'react';
import { RouteIcon, TableIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCta } from '../SectionCta';
export function LearningSystem() {
  return <section aria-labelledby="learning-system" className="bg-paper px-4 py-16 sm:py-24" data-id="element-242" data-mp="3180blbhe5kc6">
      <div className="mx-auto max-w-5xl" data-id="element-243" data-mp="2w8nnyoip498j">
        <div id="learning-system" data-id="element-244" data-mp="2w8w5itprk2q2">
          <SectionHeading kicker="For nursing professionals" title="A structured ABG learning system" subtitle="Organize your study of arterial blood gases with a clear educational pathway." data-id="element-245" data-mp="2waqhhij24ki0" />
        </div>

        <div className="mx-auto mt-10 max-w-3xl space-y-5 text-lg leading-relaxed text-ink/80" data-id="element-246" data-mp="2ihr1lffd4o9x">
          <p data-id="element-247" data-mp="2dh3ayuv1q9g8">
            Arterial blood gas interpretation involves several connected concepts:{' '}
            <strong className="text-ink" data-id="element-248" data-mp="3tutfu3tzp1qx">pH, PaCO₂, bicarbonate, respiratory and metabolic disorders, compensation</strong>, and
            the clinical context surrounding laboratory results.
          </p>
          <p data-id="element-249" data-mp="27dlwt6pk9h2k">
            When these concepts are scattered across textbooks, lecture notes, and disconnected reference charts, studying them
            can feel unnecessarily complicated.
          </p>
          <p className="rounded-2xl border-l-4 border-aqua bg-white p-5 font-semibold text-ink" data-id="element-250" data-mp="2hct9rssdv9p5">
            The ABG Clinical Roadmap™ brings these subjects together in one structured educational collection.
          </p>
        </div>

        <h3 className="mt-14 text-center font-display text-xl font-extrabold uppercase tracking-wide text-ink" data-id="element-251" data-mp="1tmqmdpzeyrwv">
          Your educational collection includes
        </h3>
        <div className="mt-6 grid gap-4 md:grid-cols-[1.4fr_1fr]" data-id="element-252" data-mp="1xn12hvgx6ypg">
          <div className="flex flex-col justify-center rounded-3xl bg-navy-900 p-7 text-white sm:p-9" data-id="element-253" data-mp="22g2i65oyb2a3">
            <p className="font-display text-7xl font-black leading-none text-cta sm:text-8xl" data-id="element-254" data-mp="15wd24ln2lxcu">
              6<span className="text-white/40" data-id="element-255" data-mp="19xolwaj9jod4"> + </span>5
            </p>
            <p className="mt-4 text-xl font-bold" data-id="element-256" data-mp="2d9401p68v2pr">Comprehensive educational volumes + specialized study bonuses</p>
            <p className="mt-2 text-white/70" data-id="element-257" data-mp="28bc6yrtv5ajz">Six volumes. Five bonuses. A more organized approach to studying ABG interpretation.</p>
          </div>
          <div className="grid gap-4" data-id="element-258" data-mp="2n1jlwxknwbfx">
            <div className="flex items-center gap-4 rounded-3xl bg-white p-6 ring-1 ring-ink/10" data-id="element-259" data-mp="2hzu8xcdvpnp7">
              <TableIcon className="h-9 w-9 shrink-0 text-navy-700" aria-hidden="true" data-id="element-260" data-mp="1ua9o0ny60gda" />
              <div data-id="element-261" data-mp="1pbye6d7ve5v2">
                <p className="font-display text-2xl font-black text-ink" data-id="element-262" data-mp="1pcq8lkpqdxjr">Multiple</p>
                <p className="text-ink/70" data-id="element-263" data-mp="23bzdvpcef78y">Reference tables, worksheets, and educational exercises</p>
              </div>
            </div>
            <div className="flex items-center gap-4 rounded-3xl bg-white p-6 ring-1 ring-ink/10" data-id="element-264" data-mp="1z8b5x5juu9n6">
              <RouteIcon className="h-9 w-9 shrink-0 text-navy-700" aria-hidden="true" data-id="element-265" data-mp="3ep1tah2rhqrj" />
              <div data-id="element-266" data-mp="3ao9j9lm2fhu7">
                <p className="font-display text-2xl font-black text-ink" data-id="element-267" data-mp="3aorkkwnl4m8z">1</p>
                <p className="text-ink/70" data-id="element-268" data-mp="3i7r7vde62xxm">Organized learning pathway</p>
              </div>
            </div>
          </div>
        </div>
        <p className="mt-4 text-center text-xs text-ink/50" data-id="element-269" data-mp="3n5aky9z4p4nz">
          These figures describe the contents of the offer, not independently verified learning outcomes.
        </p>

        <SectionCta label="Start my structured ABG roadmap" data-id="element-270" data-mp="3d9pmumx6koji" />
      </div>
    </section>;
}